import { defineComponent as t, createBlock as l, openBlock as r, unref as c, mergeProps as p, withCtx as m, createElementVNode as a } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconLanguage",
  __name: "IconLanguage",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (d, e) => (r(), l(c(u), p(o, { "view-box": "0 0 24 24" }), {
      default: m(() => e[0] || (e[0] = [
        a("path", { d: "M10.312 3.525a.75.75 0 0 0-1.5 0v1.05h-5.55a.75.75 0 0 0 0 1.5h9.028c-.298 1.306-1.147 3.229-2.966 5.094-1.032-1.272-1.483-2.579-1.75-3.381a.75.75 0 0 0-1.423.474c.288.866.817 2.413 2.068 3.926-1.236 1.028-2.806 1.999-4.785 2.79a.75.75 0 0 0 .557 1.393c2.169-.867 3.901-1.945 5.271-3.1a10.543 10.543 0 0 0 2.126 1.468.75.75 0 1 0 .699-1.328 9.087 9.087 0 0 1-1.719-1.165c2.166-2.208 3.157-4.55 3.453-6.171h2.041a.75.75 0 0 0 0-1.5h-5.55v-1.05" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "m18.353 16.725 1.693 4.04a.75.75 0 0 0 1.383-.58l-1.883-4.495-1.995-4.976a1.415 1.415 0 0 0-2.627 0l-1.995 4.976-1.883 4.495a.75.75 0 0 0 1.383.58l1.693-4.04h4.231m-2.116-5.257-1.506 3.757h3.013l-1.506-3.757",
          "clip-rule": "evenodd"
        }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  f as default
};
